import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FilesService } from 'app/main/services/filesService';
import { saveAs as importedSaveAs } from 'file-saver';
import { throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { LocalAccountService } from './localAccount.service';
import { ErrorHandlerService } from './error-handler.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private localAccountService: LocalAccountService,
    private errorHandler: ErrorHandlerService,
    private sanitizer: DomSanitizer,
    private next: HttpHandler,
    private filesService: FilesService
  ) {
    console.log('-----------ApiService Costructor!!!------------');
    // if (environment.production || environment.local) {
    //   this.URL = '/exellente/bo';
    // }
    // else {
    //   this.URL = '/localexellente/bo';
    // }
  }

  // URL: string = 'http://www.exellente.it';
  // URL: string = 'http://192.168.0.183:8200';
  // Used from CORS backend issue
  // host = 'http://localhost:8200/';

  // LOCAL
  // URL = '/api';
  // REMOTE
  URL = environment.api_base_url;
  blobData = {};



  setHeaders() {
    const token: string = this.localAccountService.getToken();
    // const token: string = '63c65b21-6bba-4eae-8456-9401d378675b';
    const headers: HttpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Basic YmFuY29tYXR1c2VyOk1hbmRhcmluby4k')
      .set('authtoken', `${token}`);
    return headers;
  }

  setFileHeaders() {
    const token: string = this.localAccountService.getToken();
    // const token: string = '63c65b21-6bba-4eae-8456-9401d378675b';
    const headers: HttpHeaders = new HttpHeaders()
      .set('authtoken', `${token}`);
    return headers;
  }

  getRequest(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.get(`${this.URL}/${endpoint}`, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  getRequestTyped(endpoint: string, myType, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.get<typeof myType>(`${this.URL}/${endpoint}`, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  getRequestPromise(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.get(`${this.URL}/${endpoint}`, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    ).toPromise();
  }

  getBlobRequest(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    if (!this.blobData[endpoint]) {
      this.blobData[endpoint] = this.http.get(`${this.URL}/${endpoint}`, { headers: headers, responseType: 'blob' }).pipe(
        catchError((err: any) => {
          this.errorHandler.handleError(err, snackbarDuration);
          return throwError(err);
        }),
        map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))),
        publishReplay(1),
        refCount()
      );
    }
    return this.blobData[endpoint];
  }

  getBlobRequestPromise(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    if (!this.blobData[endpoint]) {
      this.blobData[endpoint] = this.http.get(`${this.URL}/${endpoint}`, { headers: headers, responseType: 'blob' }).pipe(
        catchError((err: any) => {
          this.errorHandler.handleError(err, snackbarDuration);
          return throwError(err);
        }),
        map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))),
        publishReplay(1),
        refCount()
      ).toPromise();
    }
    return this.blobData[endpoint];
  }

  async downloadFile(endpoint: string, fileName: string, snackbarDuration?: number) {
    const blob = await this.getBlobRequestUnMappedPromise(endpoint);
    await importedSaveAs(blob, fileName);
  }

  async previewFile(endpoint: string, fileName: string, snackbarDuration?: number) {
    const blob = await this.getBlobRequestUnMappedPromise(endpoint);
    this.filesService.previewFile(blob);
  }

  getBlobRequestUnMapped(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.get(`${this.URL}/${endpoint}`, { headers: headers, responseType: 'blob' }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      }),
    );
  }

  getBlobRequestUnMappedPromise(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.get(`${this.URL}/${endpoint}`, { headers: headers, responseType: 'blob' }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      }),
    ).toPromise();
  }

  postRequest(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.post(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  postRequestPromise(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.post(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    ).toPromise();
  }

  postFileRequest(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setFileHeaders();
    return this.http.post(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  postFileRequestPromise(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setFileHeaders();
    return this.http.post(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    ).toPromise();
  }

  putRequest(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.put(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  putRequestPromise(endpoint: string, body: any, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.put(`${this.URL}/${endpoint}`, body, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    ).toPromise();
  }

  deleteRequest(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.delete(`${this.URL}/${endpoint}`, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    );
  }

  deleteRequestPromise(endpoint: string, snackbarDuration?: number) {
    const headers: any = this.setHeaders();
    return this.http.delete(`${this.URL}/${endpoint}`, { headers: headers }).pipe(
      catchError((err: any) => {
        this.errorHandler.handleError(err, snackbarDuration);
        return throwError(err);
      })
    ).toPromise();
  }

}
